
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`यह
                    <a href="${0}">फोल्क्सोनॉमी इंजन प्रोजेक्ट</a>द्वारा लाया गया है।
                    भाग लेने या प्रतिक्रिया देने में संकोच न करें`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`यह उपकरण आपको सामग्री सूची को सही करने की अनुमति देता है। आप
                सामग्री सूची को जोड़, हटा या संपादित कर सकते हैं।
                <br>
                यह वर्ण <span class="highlight">␣</span> एक रिक्त स्थान को दर्शाता है।
                <br>
                यह वर्ण <span class="highlight">↩︎</span> एक पंक्ति विराम को दर्शाता है। `,
'hb28f1f2ec1744ee9': html`ये गुण किसी भी प्रकार के उपयोग के लिए उपयोगकर्ताओं द्वारा बनाए और दर्ज किए जाते हैं।
                    बेझिझक अपने गुण जोड़ें। आपके द्वारा बनाए गए गुण और मान
                    <strong>तथ्यात्मक होने चाहिए</strong>। आप समुदाय द्वारा पहले से उपयोग किए जा रहे गुणों की सूची
                    <a href="${0}"></a>
                    में गोता लगा सकते हैं या
                    <a href="${1}">गुणों के दस्तावेज़ और उसके खोज इंजन</a>का अन्वेषण कर सकते हैं।`,
's000a5b76bd3a01c2': `गुण लोड हो रहे हैं...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `सामग्री के लिए हमारी मदद करें`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `फसल को मान्य करें`,
's03e9c8114521b998': `मैं सामग्री संपादित कर दूंगा`,
's05ec315d9308091a': `बारकोड कोनों आइकन`,
's061eb5af92512c85': `सहेजा गया! क्या आप किसी अन्य में मदद कर सकते हैं?`,
's06847c221c4c0bc1': `मैं [अपने उपयोग के मामले का वर्णन करने के लिए] एक संपत्ति बनाना चाहूंगा...`,
's06f6c6f99db6b552': `मूल`,
's081e2ad82db71e1d': `समूहीकृत मान`,
's09205907b5b56cda': `नहीं`,
's0b4235aae602a950': `समर्पित दस्तावेज़ीकरण`,
's0bb2d48532acc455': `CSV डाउनलोड करें`,
's0d5b7fee0311db68': `संपत्ति`,
's0fb218abc2e157ed': `छवि अमान्य करें`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `फसल रद्द करें`,
's11a18a69b30b65ed': `सामग्री सूची में त्रुटियों को ठीक करने में हमारी सहायता करें`,
's1205d5f6fccf8e69': `संपत्ति मूल्य`,
's15d64a0a6715285a': `नई कुंजी`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `चयन क्षेत्र`,
's1a52515ec8ddade8': `उत्पाद बारकोड`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `पोषण संबंधी जानकारी को सही करने में हमारी सहायता करें`,
's1e00019dc454872d': `कृपया property-name विशेषता का उपयोग करके संपत्ति का नाम प्रदान करें.`,
's1e49126af0935a5b': `इस गुण का उपयोग करने वाले उत्पादों की सूची`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `रद्द करें`,
's2db7b654c0a9bde0': `संपत्ति का दस्तावेजीकरण करें`,
's300b3a6ee4e1252d': str`खराब मिलान ${0}%`,
's33f786bb6b4f0cf4': `फसल परिणाम`,
's33f85f24c0f5f008': `सेव़`,
's34be4af4e8fec4ae': `पहले समुदाय से पूछें`,
's36d86adc823cbfa6': `नई संपत्ति बनाने से पहले, समुदाय के साथ इस पर चर्चा करें:`,
's3781d25aa51a736c': `फोल्क्सोनोमी इंजन दस्तावेज़ीकरण`,
's383ae4449428b61e': `फसल रीसेट करें`,
's39bcf88721a1e8ee': `चयन रीसेट करें`,
's39e14e14300694c7': `दस्तावेज़ीकरण और दिशानिर्देश`,
's3b430cfa5c1fe7f4': str`${0}के लिए दस्तावेज़ीकरण`,
's3f4e4b52f230a892': `छवि कैनवास`,
's417b90913e05bc17': `पूर्व दर्शन`,
's41f7dca46d3f1b4a': `मूल्य`,
's422bba9636ce2489': `केंद्र छवि`,
's42dd66b2441566fd': `केंद्र चिह्न`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `एक पोषक तत्व जोड़ें`,
's453ab0dbb9b5c777': `दाएँ आकार बदलें`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `उत्पाद संख्या`,
's4df2f533c0c1e7d0': `छवि नियंत्रण`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `चयन स्थानांतरित करें`,
's4f751fb9b3ed766c': `नई संपत्ति बनाना`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `संपत्ति का नाम दर्ज करें...`,
's55d7249883a98ca1': `ओपन फ़ूड फ़ैक्ट्स विकी पर इस संपत्ति के बारे में`,
's565867d84c04aea2': `फ़िल्टर गुण...`,
's5666afe5cd0166de': `कृपया पुष्टि करने से पहले त्रुटियों को ठीक करें या पाठ को संशोधित करें`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `उत्पाद लोड हो रहे हैं...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `पोषण संबंधी जानकारी को सही करने में हमारी सहायता करें।`,
's5dd6f12783fca34f': `सामग्री सूची संपादित करें`,
's5e8250fb85d64c23': `बंद करें`,
's5ed03bb1f3a15949': `चित्र`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `संपादित करें`,
's66413c24dcf680e2': `स्किप करें`,
's67ae6594857a4d57': `आपके योगदान के लिए धन्यवाद!`,
's6cee7cad81dfedd1': `क्रॉप की गई छवि`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`अच्छा मिलान ${0}%`,
's71a5c9f4b68ef4d4': `गिनती`,
's74cb3d66f6a668e1': `प्रलेखन`,
's787dd11bed0dc88a': `बाएँ आकार बदलें`,
's7ce4fd9430e80cea': `मूल्य`,
's801a05fa8e881f37': `संपत्ति निर्माण और दिशानिर्देशों के बारे में अधिक जानें:`,
's8038273de2cf8b73': `कृपया क्रॉप करने के लिए एक क्षेत्र चुनें.`,
's839cc2908a5387f2': `बारकोड फ़िल्टर करें...`,
's86197dcf3e96af64': `मौजूदा संपत्तियों को ब्राउज़ करें और खोजें`,
's8a63be30a129a59c': `नीचे का आकार बदलें`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `शीर्ष दाएँ का आकार बदलें`,
's8db84aa4bc949af2': `नई संपत्ति का दस्तावेजीकरण करें`,
's8f839a03997a16d7': `उत्पाद देखें`,
's901ae1e236ac45d3': `हटाना रद्द करें`,
's907f7a97c6b29425': `ध्यान रखें कि डेटा मॉडल में बदलाव किया जा सकता है। अपने जोखिम पर उपयोग करें।`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `सामग्री :`,
's9a7f60fce090ecaf': `प्रॉपर्टीज़ लोड करने में विफल. कृपया बाद में पुनः प्रयास करें.`,
's9b87abd68fb9df45': `नहीं मिला? नई कुंजी बनाएँ {value}`,
's9c0f52425fd2f07e': `मेल नहीं खा सकता`,
's9fc41f789c63b40d': `उत्पादों`,
'sa1fa766e0d5634d7': `कोई स्कोर उपलब्ध नहीं है`,
'sa548778b24054030': `फोल्क्सोनॉमी इंजन परियोजना से योगदान की गई सभी प्रॉपर्टीज़ देखें। ये प्रॉपर्टीज़ ओपन फ़ूड फ़ैक्ट्स डेटाबेस में उत्पादों के बारे में अतिरिक्त मेटाडेटा और जानकारी प्रदान करती हैं।`,
'sa63907958bd0ec4b': `ऊपर बाईं ओर आकार बदलें`,
'sa95b4224f685a36a': `मोडल बंद करें`,
'sab56a1d439576fd6': `सुझाव आइकन`,
'sac47ea2901d04c15': `नीचे बाएँ भाग का आकार बदलें`,
'sb125227d436c2925': `मौजूदा प्रॉपर्टी डेटाबेस में अपनी प्रॉपर्टी अवधारणा खोजें:`,
'sb125568d43642e6f': `उत्पाद के बारे में प्रश्नों का उत्तर दें.`,
'sb1c538e038f9b214': str`बहुत अच्छा मिलान ${0}%`,
'sb28639570ff3b852': `सभी संपत्तियों की सूची`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `एक बार जब आप यह सत्यापित कर लें कि आपकी संपत्ति मौजूद नहीं है और समुदाय इस बात से सहमत है कि यह उपयोगी है, तो आपको सबसे पहले इसे विकी में प्रलेखित करना होगा।`,
'sb3d4f79d9d8b71e5': `दर्ज करें`,
'sb560fa37a7bfb6c2': `इस संपत्ति के लिए कोई उत्पाद नहीं मिला.`,
'sb7f72e4c8a2d3357': `फ़िल्टर मान...`,
'sb8178320160f84ea': `फसल दिखाएं`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `सभी जानकारियों का उत्तर दिया गया है! आपकी मदद के लिए धन्यवाद!`,
'sbd9a0b2293b3cd3c': `सेवारत माप`,
'sbe472dc3c2685985': `संगत मूल्य`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `शीर्ष का आकार बदलें`,
'sc1c08d0cbcc3bd24': `मेल नहीं खाता`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `सुझाया गया समाधान`,
'sc681b137e8f604f7': `विलोपन की पुष्टि करें`,
'sc6daf8a31883f8b9': `छवि ले जाएँ`,
'sc895972c88d38ca5': `फोल्क्सोनोमी संपत्ति`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `पंक्तियों`,
'scb3b0671d7b7f640': `नया मूल्य`,
'scb489a1a173ac3f0': `हाँ`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `स्लैक चर्चा में शामिल हों`,
'scdb6cad0b92721bf': `कोई गुण नहीं मिला.`,
'scf23a05631f93732': `हटाने की पुष्टि करें`,
'scfed2f270ef6a3aa': `क्षेत्र चुनें`,
'sd1022bc1ef9204f7': `ज़ूम करने योग्य छवि`,
'sd1077c055cf9ba6b': `उत्पाद की सामग्री सूची को सत्यापित करने में हमारी सहायता करें।`,
'sd698d21ddecba56b': `अरे! आप निम्नलिखित भागों का उत्तर देकर उत्पाद जानकारी को बेहतर बनाने में हमारी मदद कर सकते हैं:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `जांचें कि क्या कोई संपत्ति पहले से मौजूद है`,
'sdbf806fefc584115': `आपको एक खोजना चाहिए`,
'sdc673e73b5c13aea': `नष्ट करे`,
'sdc792b75f1edcaba': `सामग्री की वर्तनी सही करने में हमारी सहायता करें।`,
'sdca5deead576ceee': `नीचे दाईं ओर आकार बदलें`,
'sdcc2555c5dde524f': `क्या आप वाकई इस आइटम को हटाना चाहते हैं? इस कार्रवाई को पूर्ववत नहीं किया जा सकता।`,
'se206feec7ec57b28': `प्रति 100 ग्राम`,
'se419a9ab36987490': `अमान्य`,
'se5127cf0f92e7e48': `टिप: आप यह भी पा सकते हैं`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `मैं बेहतर फसल का प्रस्ताव रखूंगा`,
'seea3800e27baa686': `व्यक्तिगत उत्पाद`,
'sefaba4adc4ec9219': `फोल्क्सोनोमी प्रॉपर्टीज़`,
'seffa8ca49175b5f0': `वैयक्तिकृत गुण`,
'sf44a6b3b232c28ea': str`वर्तमान मान को ${0}से प्रतिस्थापित करें`,
'sf4cd86a2f5ef2588': `उत्पाद बारकोड`,
'sf57a61152168cc81': `घटक पहचान को सही करने में हमारी सहायता करें`,
'sf88b90b8ba23871c': `अज्ञात मिलान`,
'sf9aee319a006c9b4': `डालिए`,
'sfacbbe968fa7d773': `संपत्ति का नाम:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `संगत मान`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  